/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const VehiclesIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 14"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="_HK9bYNa"
    >
      <path
        d="M2.94115 10.6177V11.3714C2.94115 11.5674 2.87375 11.7297 2.73894 11.8581C2.60414 11.987 2.4387 12.0515 2.24262 12.0515H1.58085C1.38478 12.0515 1.21933 11.987 1.08453 11.8581C0.949726 11.7297 0.882324 11.5674 0.882324 11.3714V5.61768L2.40806 1.29782C2.48159 1.08949 2.60414 0.924048 2.77571 0.801499C2.94728 0.67895 3.14335 0.617676 3.36394 0.617676H11.3051C11.5257 0.617676 11.7218 0.67895 11.8934 0.801499C12.0649 0.924048 12.1875 1.08949 12.261 1.29782L13.7867 5.61768V11.3714C13.7867 11.5674 13.7193 11.7297 13.5845 11.8581C13.4497 11.987 13.2843 12.0515 13.0882 12.0515H12.4264C12.2304 12.0515 12.0649 11.987 11.9301 11.8581C11.7953 11.7297 11.7279 11.5674 11.7279 11.3714V10.6177H2.94115ZM2.81247 4.239H11.8566L11.0661 1.99635H3.60291L2.81247 4.239ZM4.06247 8.48532C4.35659 8.48532 4.60781 8.38116 4.81615 8.17282C5.02448 7.96449 5.12865 7.71326 5.12865 7.41915C5.12865 7.12503 5.02448 6.8738 4.81615 6.66547C4.60781 6.45714 4.35659 6.35297 4.06247 6.35297C3.76835 6.35297 3.51713 6.45714 3.30879 6.66547C3.10046 6.8738 2.99629 7.12503 2.99629 7.41915C2.99629 7.71326 3.10046 7.96449 3.30879 8.17282C3.51713 8.38116 3.76835 8.48532 4.06247 8.48532ZM10.6066 8.48532C10.9007 8.48532 11.1519 8.38116 11.3603 8.17282C11.5686 7.96449 11.6728 7.71326 11.6728 7.41915C11.6728 7.12503 11.5686 6.8738 11.3603 6.66547C11.1519 6.45714 10.9007 6.35297 10.6066 6.35297C10.3125 6.35297 10.0612 6.45714 9.85291 6.66547C9.64458 6.8738 9.54041 7.12503 9.54041 7.41915C9.54041 7.71326 9.64458 7.96449 9.85291 8.17282C10.0612 8.38116 10.3125 8.48532 10.6066 8.48532Z"
        fill={fill}
        test-id="9QYACIZ4"
      />
    </svg>
  );
};

export default VehiclesIcon;
